import { onDocumentEvent } from '@app/utils/domHelpers'
import updateTitleOnSelection from '../../common/update-title-on-selection'

const handleLiveDocumentSelectChange = updateTitleOnSelection(
  '[data-behaviour~="export-element"]',
  '#export_live_document_title'
)

export default () =>
  onDocumentEvent(
    document,
    'change',
    '[data-behaviour="export-live-document-select"]',
    handleLiveDocumentSelectChange
  )
